import { DashboardLayoutContainer } from 'components/Layouts/DashboardLayout';
import { Box } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { Tab, Typography, colors } from '@leapeasy/ui-kit';
import { readStoredUser } from 'utils/authSession';
import { getVisiblePortalGuideTabs, PORTAL_GUIDE_TAB_KEYS } from 'utils/portalGuideUi';
import { GetStarted } from './GetStarted';
import Document from './Docmentation/Document';
import { FeaturedVideo } from './FeaturedVideo';

export const PortalGuide = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const tabs = useMemo(() => getVisiblePortalGuideTabs(), []);
  const currentUser = readStoredUser();
  const userRole = currentUser?.role;
  const selectedTabKey = tabs[selectedTab]?.key;

  return (
    <DashboardLayoutContainer>
      <Box>
        <Box marginBottom="15px">
          <Typography variant="h3" style={{ fontWeight: '500', color: colors.purple[900] }}>
            Portal Guide
          </Typography>
        </Box>
        <Box display="flex">
          {tabs.map((tab, index) => (
            <Tab
              key={tab.key}
              title={tab.title}
              icon={tab.icon}
              isSelected={selectedTab === index}
              onClick={() => setSelectedTab(index)}
            />
          ))}
        </Box>
        <Box marginTop="20px">
          {selectedTabKey === PORTAL_GUIDE_TAB_KEYS.GET_STARTED && <GetStarted />}
          {selectedTabKey === PORTAL_GUIDE_TAB_KEYS.DOCUMENTATION && (
            <Document userRole={userRole} />
          )}
          {selectedTabKey === PORTAL_GUIDE_TAB_KEYS.FEATURED_VIDEOS && (
            <FeaturedVideo userRole={userRole} />
          )}
        </Box>
      </Box>
    </DashboardLayoutContainer>
  );
};
